import React, { useState } from 'react';
import { NavLink, useNavigate, useLocation } from 'react-router-dom';
import { useApp } from '@/context/AppContext';
import { bottomNavItems, navGroups } from '@/config/nav';
import { Menu } from 'lucide-react';
import { Sheet, SheetContent, SheetTrigger, SheetHeader, SheetTitle, SheetDescription } from '@/components/ui/sheet';

export const BottomNav = () => {
  const { t } = useApp();
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const go = (path) => { navigate(path); setOpen(false); };

  return (
    <nav className="app-chrome lg:hidden fixed bottom-0 inset-x-0 z-40 flex items-stretch justify-around px-1 pb-safe border-t" data-testid="bottom-nav">
      {bottomNavItems.map((item) => (
        <NavLink
          key={item.key}
          to={item.path}
          data-testid={`bottomnav-${item.key}`}
          className={({ isActive }) => `flex flex-col items-center justify-center gap-0.5 flex-1 py-2.5 text-[10px] ${isActive ? 'text-cyan-600 dark:text-cyan-400' : 'text-zinc-500 dark:text-zinc-400'}`}
        >
          <item.icon className="w-5 h-5" strokeWidth={2} />
          <span>{t(item.labelKey)}</span>
        </NavLink>
      ))}
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild>
          <button data-testid="bottomnav-more" className="flex flex-col items-center justify-center gap-0.5 flex-1 py-2.5 text-[10px] text-zinc-500 dark:text-zinc-400">
            <Menu className="w-5 h-5" strokeWidth={2} />
            <span>{t('nav.more')}</span>
          </button>
        </SheetTrigger>
        <SheetContent side="bottom" className="rounded-t-2xl max-h-[80vh] overflow-y-auto">
          <SheetHeader className="text-left"><SheetTitle className="font-heading">FINPULSE</SheetTitle><SheetDescription className="sr-only">{t('nav.more')}</SheetDescription></SheetHeader>
          <div className="mt-4 space-y-5 pb-6">
            {navGroups.map((group) => (
              <div key={group.labelKey}>
                <p className="text-[10px] tracking-[0.2em] uppercase font-semibold text-zinc-400 mb-2">{t(group.labelKey)}</p>
                <div className="grid grid-cols-3 gap-2">
                  {group.items.map((item) => {
                    const active = location.pathname === item.path;
                    return (
                      <button
                        key={item.key}
                        onClick={() => go(item.path)}
                        data-testid={`more-${item.key}`}
                        className={`flex flex-col items-center gap-1.5 p-3 rounded-xl border text-xs ${active ? 'border-cyan-300 bg-cyan-50 text-cyan-700' : 'border-zinc-200 text-zinc-600'}`}
                      >
                        <item.icon className="w-5 h-5" />
                        <span className="text-center leading-tight">{t(item.labelKey)}</span>
                      </button>
                    );
                  })}
                </div>
              </div>
            ))}
          </div>
        </SheetContent>
      </Sheet>
    </nav>
  );
};
